import { render, staticRenderFns } from "./RoadWorthyTableSingle.vue?vue&type=template&id=37d88df1&"
import script from "./RoadWorthyTableSingle.vue?vue&type=script&lang=js&"
export * from "./RoadWorthyTableSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports